module.exports = __webpack_public_path__ + "img/expanded.e603de99.svg";